module.exports = ol.source.TileImage;